import React from 'react'
import { Card, Button, Row, Form } from 'antd'
import { SchemaForm } from 'xadmin-form'
import { regForm } from '../schema'
import { Icon, C } from 'xadmin-ui';
import { app, use } from 'xadmin'
import LogoComponent from './LogoComponent'

const DefaultLayout = props => {
  const { children, invalid, handleSubmit, submitting } = props;
  const { _t } = app.context;
  return (
    <Form onSubmit={handleSubmit} layout="vertical">
      <Card style={{ marginTop: 0, borderTop: 'none' }}>
        {children}
        <Row>
          <Button type="primary" loading={submitting} className="loginBtn" onClick={handleSubmit} htmlType="submit" disabled={invalid}>{_t('注册')}</Button>
        </Row>
      </Card>
    </Form>
  )
}

const Reg = props => {
  const { showCode, showExtra, onSubmit } = use('auth.reg', props)

  return (
    <div className="setGuideCard">
      <div className="guideContent" style={{ width: '648px', margin: '0 auto', borderRadius: '5px' }}>
        <div style={{ maxWidth: '688px', background: 'rgba(255,255,255,.1)', padding: '28px' }}>
          <div style={{ maxWidth: '648px', background: 'rgba(255,255,255,.26)', padding: '28px' }}>
            <div className="loginGuide" >
              <div className="loginBox">
                <LogoComponent></LogoComponent>
                <p className="guideUse">注册新账号</p>
              </div> 
              <SchemaForm
                formKey={'setRegGuide'}
                schema={regForm}
                component={DefaultLayout}
                group={C('Form.SimpleGroup')}
                onSubmit={(value)=>onSubmit(value)}
              />
              <div className="loginBox">
                <p className="goReg goLogin" onClick={()=>app.go('/login')}>已有账号，去登录-></p>
                {/* <p><span className="span-middle"></span><span className="span-login">第三方登录</span><span className="span-middle"></span></p> */}
                {/* <div className="login-way-box">
              <div className="login-way">
                <img src={require('./../images/weixin.png')} alt=""/>
                <p className="login-desc">微信登录</p>
              </div>
              <div className="login-way">
                <img src={require('./../images/QQ.png')} alt=""/>
                <p className="login-desc">QQ登录</p>
              </div>
            </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Reg
